/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Date_RequiredInputs */

const vi_einvoice_err_date_required = /** @type {(inputs: Einvoice_Err_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn ngày hóa đơn`)
};

/**

* @param {Einvoice_Err_Date_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_date_required = /** @type {((inputs?: Einvoice_Err_Date_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Date_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_date_required(inputs)
});